import { render, staticRenderFns } from "./phoneQrcode.vue?vue&type=template&id=c99617c0&scoped=true&"
import script from "./phoneQrcode.vue?vue&type=script&lang=js&"
export * from "./phoneQrcode.vue?vue&type=script&lang=js&"
import style0 from "./phoneQrcode.vue?vue&type=style&index=0&id=c99617c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99617c0",
  null
  
)

export default component.exports